import { render } from "./TcCompile.vue?vue&type=template&id=0afcada1&scoped=true"
import script from "./TcCompile.vue?vue&type=script&lang=js"
export * from "./TcCompile.vue?vue&type=script&lang=js"

import "./TcCompile.vue?vue&type=style&index=0&id=0afcada1&scoped=true&lang=less"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afcada1"]])

export default __exports__